<template>
  <router-link
    :to="`/regions/${item.code}`"
    class="relative flex items-center justify-between p-4 border hover:shadow-md transition-shadow overflow-hidden rounded-md"
    @mouseenter="isHovered = true"
    @mouseleave="isHovered = false"
  >
    <ClipCorner :is-hovered="isHovered" />

    <div class="flex items-center gap-4 flex-1 min-w-0 relative z-10">
      <div
        class="w-12 h-12 rounded-md border flex items-center justify-center overflow-hidden relative before:absolute before:inset-0 before:bg-[repeating-linear-gradient(-45deg,var(--color-border),var(--color-border)_1px,transparent_1px,transparent_6px)] before:opacity-50 before:rounded-md"
      >
        <img
          v-if="!imageError"
          :src="`https://flagcdn.com/${item.code.toLowerCase()}.svg`"
          :alt="item.name"
          class="w-full h-full object-cover z-10"
          loading="lazy"
          @error="handleImageError"
        />
        <Globe v-else :size="24" class="text-gray-500 z-10" />
      </div>
      <div class="min-w-0 flex-1">
        <h3 class="font-semibold truncate">{{ item.name }}</h3>
        <p class="text-sm text-gray-300 truncate">
          From US ${{ item.from }}
          <span v-if="'countries' in item && item.countries">
            • {{ item.countries }} countries</span
          >
        </p>
      </div>
    </div>
  </router-link>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { Globe } from "lucide-vue-next";
import { ClipCorner } from "@/components/ui/clip-corner";
import type { PopularCountry, PopularRegionGroup } from "@/lib/types";

interface Props {
  item: PopularCountry | PopularRegionGroup;
}

defineProps<Props>();

const isHovered = ref(false);
const imageError = ref(false);

const handleImageError = () => {
  imageError.value = true;
};
</script>
